




























































import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

import { Design } from "@/model/document2/page/surface/design/design";
import { Layer } from "@/model/document2/page/surface/design/layer/layer";

import { Rectangle } from "@/utilityModels/rectangle";

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import AlignControl from "../alignControl/alignControl.vue";

@Component({
  components: {
    ValueEdit,
    ArrowDown,
    ArrowRight,
    AlignControl
  }
})
export default class MultiplePosition extends Vue 
{
    @Prop() private design!: Design;

    // TextEditorのfocusLockを解除する
    private unlockTextEditorFocus() {
        // メッセージセンター取得
        var messageCenter = this.$store.getters.messageCenter;
        // メッセージセンターに送信
        messageCenter.send("unlock_text_editor_focus", null);
    }

    private getSelectedLayers() : Array<Layer>
    {
        return this.design.getSelectLayerWithoutGroup();
    }
 
    // すべての選択レイヤーの外接矩形を取得
    private getBounds() : Rectangle
    {
        var rect = new Rectangle();

        var layers = this.getSelectedLayers();
        var minX = 0;
        var minY = 0;
        var maxX = 0;
        var maxY = 0;
        for(var i = 0; i < layers.length; ++i)
        {
            var layer = layers[i];
            var bounds = layer.getBoundingRect();
            minX = i == 0 ? bounds.x : Math.min(bounds.x, minX);
            minY = i == 0 ? bounds.y : Math.min(bounds.y, minY);
            maxX = i == 0 ? bounds.right : Math.max(bounds.right, maxX);
            maxY = i == 0 ? bounds.bottom : Math.max(bounds.bottom, maxY);
        }
        rect.x = minX;
        rect.y = minY;
        rect.width = maxX - minX;
        rect.height = maxY - minY;

        return rect;
    }

    private get x() 
    {
        return this.getBounds().x;
    }
    
    private get y() 
    {
        return this.getBounds().y;
    }

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい → storeから直接取ってくることになった
    openStatus = {
        opend: true
    };

    multiplePositionContentsOpenAnimate = false;
    multiplePositionContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
        this.multiplePositionContentsCloseAnimate = true;
        setTimeout(() => {
            this.openStatus.opend = false;
            this.multiplePositionContentsOpenAnimate = false;
            this.multiplePositionContentsCloseAnimate = false;
        }, 200);
        } else {
        this.openStatus.opend = true;
        this.multiplePositionContentsOpenAnimate = true;
        setTimeout(() => {
            this.multiplePositionContentsOpenAnimate = false;
        }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑
    private deleteLayer() 
    {
        // 選択レイヤー削除
        this.$emit("doCommand", "deleteSelectedLayer");
    }

    private onChangingValue(value: number, tag: string) 
    {
        this.moveLayer(value, tag, false);
    }

    private onChangedValue(value: number, tag: string) 
    {
        this.moveLayer(value, tag, true);
    }

    private moveLayer(value : number, propertyName : string, isFinish : boolean = false)
    {
        var deltaX = 0;
        var deltaY = 0;
        if(propertyName == "x")
        {
            deltaX = value - this.x;
        }
        else if(propertyName == "y")
        {
            deltaY = value - this.y;
        }

        this.$emit("doCommand", "moveMultipleLayers", { deltaX : deltaX, deltaY : deltaY, layers: this.getSelectedLayers() });
    }
    
    // レイヤーの整列
    private align(direction: 'horizontal' | 'vertical', alignment: string)
    {
        if (direction === 'horizontal')
        {
            this.$emit("doCommand", "alignMultiLayersHorizontal", { layers: this.getSelectedLayers(), alignment });
        }
        else
        {
            this.$emit("doCommand", "alignMultiLayersVertical", { layers: this.getSelectedLayers(), alignment });
        }
    }

    private changeLayerProperty(value : any, propertyName : string, isFinish : boolean = false)
    {
        this.$emit("doCommand", "changeMultipleLayersProperty", { value : value, propertyName : propertyName, layers: this.getSelectedLayers() });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigFontColor(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
}
